import { render, staticRenderFns } from "./RadiosColors.vue?vue&type=template&id=45f66642&"
import script from "./RadiosColors.vue?vue&type=script&lang=js&"
export * from "./RadiosColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports